import router from '@/router';
import store from '@/store';

import Auth from '@/services/Auth';

router.beforeEach(async (to, from, next) => {
	store.dispatch('Notifications/getNotificationsBanner');

	if (!Auth.checkPermission('LOGGED_IN')) {
		next();
		return;
	}
	try {
		store.dispatch('Notifications/getNotifications');
	} catch (e) {
		console.log(e);
	}

	next();
});
